import styled, { css } from 'styled-components';
import theme from '@shared/theme';
import { weightMap } from '@shared/weightMap';
import { Breakpoints } from '@shared/styles/breakpoints';

export type TextProps = {
    font?: 'primary' | 'secondary';
    weight?: keyof typeof weightMap;
    size?: keyof typeof theme.sizing;
    spacing?: keyof typeof theme.spacing;
    lineHeight?: keyof typeof theme.sizing;
    color?: keyof typeof theme.colors | 'inherit';
    align?: 'left' | 'right' | 'center';
    $useSmartMobileSizing?: boolean;
    as?: string;
};

const TEXT_SIZES = Object.keys(theme.sizing) as (keyof typeof theme.sizing)[];

export function getPreviousTextSize(
    key: keyof typeof theme.sizing
): keyof typeof theme.sizing {
    const index = TEXT_SIZES.indexOf(key);
    if (index === 0) return key;
    return TEXT_SIZES[index - 1];
}

const asVariantStyles = (as = 'p') =>
    ({
        p: css``,
        button: css`
            border: none;
            background: none;
            padding: 0;
            cursor: pointer;
            transition: opacity 0.2s ease-in-out;

            &:hover {
                opacity: 0.8;
            }
        `,
        span: css`
            display: inline-block;
        `,
    }[as]);

export const Text = styled.p<TextProps>`
    font-family: ${({ font, theme }) =>
        theme.fonts[font || 'secondary'].regular};
    font-weight: ${({ weight }) => weightMap[weight || 'regular']};
    font-size: ${({ size, theme }) =>
        typeof size === 'number'
            ? `${size}px`
            : theme.sizing[size || 'medium'].size};
    color: ${({ color }) =>
        color === 'inherit' ? 'inherit' : theme.colors[color || 'uNavy']};

    line-height: ${({ lineHeight, size, theme }) =>
        lineHeight === undefined
            ? theme.sizing[(size as keyof typeof theme.sizing) || 'medium']
                  .lineHeight
            : typeof lineHeight === 'string'
            ? theme.sizing[lineHeight].lineHeight
            : `${lineHeight}`};
    text-align: ${({ align }) => align};

    margin-bottom: ${({ font, spacing, theme }) =>
        spacing ? theme.spacing[spacing] : font === 'primary' ? '-.2em' : '0'};

    // Variant styles
    ${(props) => asVariantStyles(props.as)}

    ${({ $useSmartMobileSizing = true, size, lineHeight }) => {
        if (!$useSmartMobileSizing) return;

        return `
            @media (max-width: ${Breakpoints.Medium}) {
                font-size: ${
                    theme.sizing[getPreviousTextSize(size || 'medium')].size
                };
                line-height: ${
                    theme.sizing[
                        getPreviousTextSize(lineHeight || size || 'medium')
                    ].lineHeight
                };
            }
        `;
    }}
`;
